import React from "react";

import './footer-fn';
import './footer.scss';
import { getCurrentYear } from "./footer-fn";

function Footer() {
    return (
        <footer>
            Copyright &copy; {getCurrentYear()} Salty - All rights reserved
        </footer>
    );
}

export default Footer;